import { render, staticRenderFns } from "./ForgotPasswordStep3.vue?vue&type=template&id=06c3ccb1&"
import script from "./ForgotPasswordStep3.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordStep3.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordStep3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports